import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { useFetchMasses } from '../../api/actions/useFetchMasses';
import selectors from '../../store/selectors';

import MassList from './MassList';

const MassListContainer = ({ inboxDictionary }) => {
  const accountId = useSelector(selectors.getAccountId);
  const anytimeFetchedMasses = useSelector(selectors.anytimeFetchedMasses);
  const selectedMassId = useSelector(selectors.getSelectedMassId);

  useFetchMasses(accountId);

  return (
    selectedMassId === null &&
    anytimeFetchedMasses && <MassList inboxDictionary={inboxDictionary} />
  );
};

MassListContainer.propTypes = {
  inboxDictionary: PropTypes.array,
};

export default MassListContainer;
